// Firebase 설정
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  // 여기에 Firebase 프로젝트 설정을 넣으세요
  // Firebase 콘솔에서 프로젝트 설정 > 일반 > 웹 앱에서 확인 가능
  apiKey: "AIzaSyAlZfRiTgj-6yDVSKDMWgQHndFeE6WtoEM",
  authDomain: "codegrove-site.firebaseapp.com",
  projectId: "codegrove-site",
  storageBucket: "codegrove-site.firebasestorage.app",
  messagingSenderId: "798997477215",
  appId: "1:798997477215:web:1ff53addb81dcd809768ea",
  measurementId: "G-V2VCMHYDXL"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);

// Analytics 초기화 (브라우저 환경에서만, 테스트 환경 제외)
let analytics = null;
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'test') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;
